const CAPABILITIES = {
  canLogin: 1n << 0n,
  canPlay: 1n << 1n,
  canEngageInPromotionalPlay: 1n << 2n,
  canPurchase: 1n << 3n,
  canAccruePromotionalTokens: 1n << 4n,
  canRedeem: 1n << 5n,
  canRequestAmoe: 1n << 6n,
  canAccessPeriodicBonus: 1n << 7n,
} as const

export type AccountCapabilities = {
  [K in keyof typeof CAPABILITIES]: boolean
}

/**
 * Decodes a bigint value into account capabilities
 */
export const decodeCapabilities = (
  cid: bigint | number | string,
): AccountCapabilities => {
  const result: Record<string, boolean> = {}

  cid = BigInt(cid)

  for (const [capability, mask] of Object.entries(CAPABILITIES)) {
    result[capability] = (cid & mask) !== 0n
  }

  return result as AccountCapabilities
}
